<template>
  <div 
    class="sm-input-text-wrap"
    :class="{
      'error': error && error.length
    }"
  >
    <label v-if="label">
      {{label}}
      <hint-wrap
        v-if="hint"
        :text="hint"
        :left="true"
      >
        <template slot="content">
          <include-svg :name="'icon-hint'" />
        </template>
      </hint-wrap>
    </label>
    <input 
      v-if="!isTextarea"
      class="sm-input-text"
      :class="{
        'password': type == 'password',
        'disabled': disabled
      }"
      :type="curType" 
      :placeholder="placeholder"
      :name="name"
      :value="value"
      :autocomplete="autocomplete"
      @input="handleInput"
      @blur="$emit('blur', $event);"
      @focus="$emit('focus', $event)"
      @change="$emit('change', $event);"
    >
    <textarea
      v-else 
      class="sm-input-text textarea"
      :class="{'disabled': disabled}"
      :placeholder="placeholder"
      :name="name"
      :value="value"
      @input="handleInput"
      @blur="$emit('blur', $event);"
      @focus="$emit('focus', $event)"
      @change="$emit('change', $event);"
    ></textarea>
    <span 
      v-if="type == 'password'"
      @click="togglePass"
    >
      <svg 
        v-if="!showPass"
        class="sm-icons sm-icon-show-pass"
      >
        <use xlink:href="#icon-show-pass"/>
      </svg>
      <svg 
        v-if="showPass"
        class="sm-icons sm-icon-hide-pass"
      >
        <use xlink:href="#icon-hide-pass"/>
      </svg>
    </span>
    <hint-wrap
      style="margin-left: 10px"
      v-if="inputHint"
      :text="inputHint"
      :left="true"
    >
      <template slot="content">
        <include-svg :name="'icon-hint'" />
      </template>
    </hint-wrap>
    <span
      v-if="error && error.length"
      class="sm-input-text-error"
    >
      {{error}}
    </span>
    <span 
      v-if="showLoader"
      class="sm-loader"
    ></span>
  </div>
</template>

<script>
import HintWrap from '@/components/HintWrap';

export default {
  name: 'input-text',
  components: {
    'hint-wrap': HintWrap
  },
  data() {
    return {
      showPass: false,
      curType: this.type
    }
  },
  created() {
    this.$validator.extend('first_name_validator', {
      getMessage: field =>  {
        return 'First Name must only contain letters or apstrophe.';
      },
      validate: (value) => {
        let regex=/^[A-Za-z']+$/
        return regex.test(value);
      }
    });
    this.$validator.extend('last_name_validator', {
      getMessage: field =>  {
        return 'Last Name must only contain letters,digits,dash or apstrophe.';
      },
      validate: (value) => {
        let regex=/^[A-Za-z\d_']+$/
        return regex.test(value);
      }
    });
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String | Number,
      default: ''
    },
    error: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: null
    },
    showLoader: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    inputHint: {
      type: String,
      default: ''
    },
    isEmail: {
      type: Boolean,
      default: false
    },
    isTextarea:{ 
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    togglePass() {
      this.showPass = !this.showPass;
      this.curType = this.showPass ? 'text' : 'password';
    },
    handleInput(e) {
      this.$emit('input', this.isEmail ? e.target.value.toLowerCase() : e.target.value);
    }
  }
}
</script>